import './AppMonitorsCell.scss';
import { EditBox } from '@ui/EditBox';
import { getMonitorRoute } from '@lib/routes';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EditOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { Else, If, Then } from 'react-if';
export const AppMonitorsCell = ({ applicationId, monitors }) => {
    const navigate = useNavigate();
    return (React.createElement(EditBox, { className: 'app-monitor-cell', isSpreadsheet: true, onClick: () => navigate(getMonitorRoute(applicationId)) },
        React.createElement(If, { condition: monitors.length > 0 },
            React.createElement(Then, null,
                monitors.map((monitor) => React.createElement("div", { key: monitor.monitorName }, monitor.monitorName)),
                React.createElement("div", { className: 'edit-icons' },
                    React.createElement(EditOutlined, { className: 'edit-icon' }))),
            React.createElement(Else, null,
                React.createElement("div", { className: 'add-icons' },
                    React.createElement(PlusSquareOutlined, null))))));
};
